const getContent = function (element) {
    const clone = element.querySelector('.brandspace__slider-item-clone');
    return clone ? clone.innerHTML : '';
};
// ** FADE IN FUNCTION **
const fadeIn = (el) => {
    el.removeEventListener('animationend', function () {
        fadeIn(el);
    });
    el.classList.remove('fadeOut');
    el.classList.add('fadeIn');
};
const fadeOut = (el, contentClone, item) => {
    el.addEventListener('animationend', function () {
        contentClone.innerHTML = getContent(item);
        fadeIn(el);
    });
    el.classList.remove('fadeIn');
    el.classList.add('fadeOut');
};
const indexInParent = (node) => {
    const children = node.parentNode ? node.parentNode.childNodes : [];
    let num = 0;
    for (let i = 0; i < children.length; i++) {
        if (children[i] == node) {
            return num;
        }
        if (children[i].nodeType == 1) {
            num++;
        }
    }
    return -1;
};
const setClassActive = (wrapper, element) => {
    const active = wrapper.querySelector('.active');
    if (active) {
        active.classList.remove('active');
    }
    element.classList.add('active');
};
const setHeightContent = (wrapper, content) => {
    wrapper.style.height = content.offsetHeight + ' px';
    //Maybe get top and bottom margin if needs
};
const setOffsetLeft = (wrapper, element, content, numberOfItems) => {
    const offsetLeft = element.offsetLeft;
    const itemWidth = element.offsetWidth;
    const contentWidth = content.offsetWidth;
    let resultOffsetLeft = offsetLeft - (contentWidth - itemWidth) / 2;
    if (resultOffsetLeft < 0) {
        resultOffsetLeft = 0;
    }
    const elementIndex = indexInParent(element);
    const itemPerRow = Math.floor(wrapper.offsetWidth / itemWidth);
    if (elementIndex + 1 >= numberOfItems || elementIndex + 1 >= itemPerRow) {
        content.style.left = wrapper.offsetWidth + 'px';
        content.style.transform = 'translateX(-100%)';
    }
    else {
        content.style.left = resultOffsetLeft + 'px';
        content.style.transform = 'translateX(0)';
    }
};
const changeContent = (wrapper, content, contentClone, item, numberOfItems) => {
    fadeOut(content, contentClone, item);
    setOffsetLeft(wrapper, item, content, numberOfItems);
    content.style.top = item.offsetTop - 58 + 'px';
};
const init = () => {
    const wrapper = document.querySelector('.brandspace__slider');
    const content = document.querySelector('.brandspace__slider-content');
    const contentClone = document.querySelector('.brandspace__slider-content-clone');
    const items = document.querySelectorAll('.brandspace__slider-item');
    let resizeTimer = null;
    if (!wrapper || !content || !contentClone) {
        return;
    }
    const numberOfItems = wrapper.querySelectorAll('.brandspace__slider-item').length;
    setHeightContent(wrapper, content);
    window.addEventListener('resize', () => {
        const item = document.querySelector('.brandspace__slider-item.active');
        if (!item) {
            return;
        }
        if (resizeTimer !== null) {
            clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(() => {
            changeContent(wrapper, content, contentClone, item, numberOfItems);
        }, 100);
    });
    items.forEach((item) => {
        item.addEventListener('click', () => {
            setClassActive(wrapper, item);
            setHeightContent(wrapper, content);
            changeContent(wrapper, content, contentClone, item, numberOfItems);
        });
    });
    content.querySelectorAll('.brandspace__slider-content-prev').forEach((prev) => {
        prev.addEventListener('click', () => {
            const active = wrapper.querySelector('.active');
            if (!active) {
                return;
            }
            let target;
            if (active.parentElement && indexInParent(active) === 0) {
                target = active.parentElement.lastElementChild;
            }
            else {
                target = active.previousElementSibling;
            }
            if (!target) {
                return;
            }
            target.dispatchEvent(new Event('click'));
        });
    });
    content.querySelectorAll('.brandspace__slider-content-next').forEach((next) => {
        next.addEventListener('click', () => {
            const active = wrapper.querySelector('.active');
            if (!active) {
                return;
            }
            let target;
            if (active.parentElement && active.nextElementSibling == null) {
                target = active.parentElement.firstElementChild;
            }
            else {
                target = active.nextElementSibling;
            }
            if (!target) {
                return;
            }
            target.dispatchEvent(new Event('click'));
        });
    });
};
export default () => {
    init();
};
